module.exports = __webpack_public_path__ + "static/media/24.32c2d7aa.jpg";